export default "__VITE_ASSET__d0e88b4f__"